import React from "react";

interface Service {
  title: string;
  description: string;
  icon: React.ReactNode;
  features: string[];
}

export const services: Service[] = [
  {
    title: "Cable Railing",
    description: "Contemporary cable railing systems that provide unobstructed views while meeting all safety requirements.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" 
    })),
    features: [
      "Marine-grade stainless steel cable",
      "Custom post designs",
      "Indoor and outdoor installations",
      "Code-compliant systems"
    ]
  },
  {
    title: "Indoor Railing",
    description: "Elegant interior railings that enhance your home's aesthetic while providing essential safety features.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" 
    })),
    features: [
      "Modern glass panel systems",
      "Traditional wrought iron designs",
      "Wood and metal combinations",
      "Custom newel posts and balusters"
    ]
  },
  {
    title: "Ornamental Work",
    description: "Artistically crafted metal elements that add character and distinction to any architectural space.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" 
    })),
    features: [
      "Decorative fencing and gates",
      "Artistic metal sculptures",
      "Period-authentic reproductions",
      "Customized metal scrollwork"
    ]
  },
  {
    title: "Outdoor Railing",
    description: "Weather-resistant, durable exterior railings that beautify your property while providing safety for stairs, decks, and balconies.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" 
    })),
    features: [
      "Powder-coated aluminum systems",
      "Rust-resistant finishes",
      "Deck and patio railings",
      "Custom gate integration"
    ]
  },
  {
    title: "Spiral Stairs",
    description: "Space-saving, visually stunning spiral staircases custom-designed to fit your specific requirements and style preferences.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" 
    })),
    features: [
      "Custom diameter and height options",
      "Various tread designs",
      "Integrated railing systems",
      "Indoor and outdoor applications"
    ]
  },
  {
    title: "Stainless Steel",
    description: "Premium stainless steel fabrication for corrosion-resistant, modern applications requiring strength and aesthetic appeal.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" 
    })),
    features: [
      "Marine-grade 316 stainless",
      "Custom polishing and finishes",
      "Architectural applications",
      "Food-grade fabrication available"
    ]
  },
  {
    title: "Steel Fabrication",
    description: "Comprehensive steel fabrication services for structural, architectural, and custom applications of any complexity.",
    icon: React.createElement("svg", { 
      xmlns: "http://www.w3.org/2000/svg", 
      className: "h-10 w-10", 
      fill: "none", 
      viewBox: "0 0 24 24", 
      stroke: "currentColor" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" 
    }, React.createElement("path", { 
      strokeLinecap: "round", 
      strokeLinejoin: "round", 
      strokeWidth: 2, 
      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
    }))),
    features: [
      "Structural steel components",
      "Artistic and architectural elements",
      "Precision cutting and forming",
      "Multi-material integration"
    ]
  }
];